import {extendCrudApiByHousehold} from '@/utils/api.js';

const invalidatesRecipesAndTags = (result, error, arg) => [
  { type: 'Recipes', id: 'LIST', householdId: arg.householdId },
  { type: 'Tags', id: 'LIST', householdId: arg.householdId },
];

const recipesApi = extendCrudApiByHousehold({
  entityNameSingular: 'Recipe',
  entityNamePlural: 'Recipes',
  entityPath: 'recipes',
  extraTags: ['Tags'],
  extraEndpoints: (builder) => ({
    createRecipe: builder.mutation({
      query: ({ householdId, data }) => ({
        url: `/h/${householdId}/recipes/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: invalidatesRecipesAndTags,
    }),
    updateRecipe: builder.mutation({
      query: ({ householdId, id, data }) => ({
        url: `/h/${householdId}/recipes/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'Recipes', id: arg.id, householdId: arg.householdId },
        { type: 'Tags', id: 'LIST', householdId: arg.householdId },
      ],
    }),
    createRecipeFromURL: builder.mutation({
      query: ({ householdId, url }) => ({
        url: `/h/${householdId}/recipes/from-url`,
        method: 'POST',
        body: { url },
      }),
      invalidatesTags: invalidatesRecipesAndTags,
    }),
    createRecipeFromText: builder.mutation({
      query: ({ householdId, text }) => ({
        url: `/h/${householdId}/recipes/from-text`,
        method: 'POST',
        body: { text },
      }),
      invalidatesTags: invalidatesRecipesAndTags,
    }),
    createRecipeFromImage: builder.mutation({
      query: ({ householdId, file }) => {
        const formData = new FormData();
        formData.append('image', file);
        return {
          url: `/h/${householdId}/recipes/from-image`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: invalidatesRecipesAndTags,
    }),
    uploadRecipeImage: builder.mutation({
      query: ({ householdId, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/h/${householdId}/recipes/images/upload`,
          method: 'POST',
          body: formData,
        };
      },
    }),
  }),
});

const SIGNED_URL_REFETCH_SECONDS = 12 * 60 * 60;

recipesApi.enhanceEndpoints({
  endpoints: {
    getRecipes: {
      refetchOnMountOrArgChange: SIGNED_URL_REFETCH_SECONDS,
    },
    getRecipe: {
      refetchOnMountOrArgChange: SIGNED_URL_REFETCH_SECONDS,
    },
  },
});

export const {
  useGetRecipesQuery,
  useGetRecipeQuery,
  useUpdateRecipeMutation,
  useDeleteRecipeMutation,
  useCreateRecipeMutation,
  useCreateRecipeFromURLMutation,
  useCreateRecipeFromTextMutation,
  useCreateRecipeFromImageMutation,
  useUploadRecipeImageMutation,
} = recipesApi;
